import { ROUTES } from '@/utils'

const formatRoute = (route: string, paramMap: Record<string, string> = {}): string => {
  return route.replace(/\{([^}]+)\}/g, (_, key) => {
    const mappedKey = paramMap[key] ?? key
    return `[${mappedKey}]`
  })
}

export const PAGE_TITLE: Record<string, string> = {
  [ROUTES.HOME]: 'home',
  [ROUTES.ABOUT_US]: 'about-us',
  [ROUTES.CONTACT_US]: 'contact-us',
  [ROUTES.GROUPS]: 'groups',
  [ROUTES.TRAVEL]: 'travel',
  [ROUTES.PRIVACY]: 'privacy',
  [ROUTES.LOGIN]: 'login',
  [ROUTES.EVENT_LIST]: 'event-list',
  [ROUTES.PACKAGE.BASE]: 'build-package',
  [formatRoute(ROUTES.PACKAGE.TICKET_SELECT, { packageId: 'eventId' })]: 'ticket',
  [ROUTES.PACKAGE.ADD_ONS]: 'add-ons',
  [ROUTES.PACKAGE.HOTEL_SEARCH]: 'hotel-search',
  [ROUTES.PACKAGE.HOTEL_RESULTS]: 'hotel-results',
  [formatRoute(ROUTES.PACKAGE.HOTEL_DETAILS)]: 'hotel-details',
  [ROUTES.PACKAGE.FLIGHTS_SEARCH]: 'flight-search',
  [ROUTES.PACKAGE.FLIGHTS_DEPARTURE]: 'flight-segment',
  [formatRoute(ROUTES.PACKAGE.FLIGHTS_RETURN)]: 'flight-segment',
  [ROUTES.PACKAGE.SESSION_EXPIRED]: 'session-expired',
  [ROUTES.PACKAGE.CONTACT_INFO]: 'contact-info',
  [ROUTES.PACKAGE.REVIEW_PACKAGE]: 'review-package',
  [ROUTES.PACKAGE.CHECKOUT]: 'checkout',
  [ROUTES.USER.PROFILE]: 'user-profile',
  [ROUTES.SERVER_ERROR]: 'server-error',
  SPORTS: 'event-sport-list',
  VENUE: 'event-venue-list',
  ARTIST: 'event-artist-list',
  LEAGUE: 'league',
}

export const EXCLUDED_PATHS = ['/[...dynamic-page]']
